import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Text,
} from "@microbeta/ui";
import { useTranslation } from "react-i18next";
import { languages } from "../../../../features/i18n/i18n";
import styles from "./language-dropdown-item.module.scss";

export const LanguageDropdownItem = () => {
  const { i18n } = useTranslation();

  const handleLanguageChange = (languageCode: string) => {
    i18n.changeLanguage(languageCode);
  };

  return (
    <div className={styles.languageMenuItem}>
      <Select value={i18n.language} onValueChange={handleLanguageChange}>
        <SelectTrigger className={styles.languageSelect}>
          <SelectValue placeholder="Select language..." />
        </SelectTrigger>
        <SelectContent className={styles.languageOptions}>
          {languages.map((language) => (
            <SelectItem key={language.code} value={language.code}>
              <span className={styles.languageOption}>
                <Text variant="medium">{language.flag}</Text>
                <Text variant="medium">{language.name}</Text>
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
